import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAllRecharge,
  StatusRecharge,
} from "../../../../features/admin/recharge_management/recharge/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const recharge = useSelector((state) => state.recharge_managements.recharge);
  const [vehicleType, setVehicleType] = useState("");

  const [name, setName] = useState("");

  const fetch = async (page = recharge?.current_page) => {
    // await dispatch(Allrecharge());
    await dispatch(
      GetAllRecharge({
        name: name,
        vehicleType: vehicleType?.value,
        page: page,
        per_page: recharge?.per_page,
      }),
    );
  };
  useEffect(() => {
    fetch();
  }, [name, vehicleType]);

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(StatusRecharge(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    recharge,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
    vehicleType,
    setVehicleType,
  };
};
